import React, { FC, useEffect, useState } from 'react';

import { FormikValues, useFormik } from 'formik';
import { Box } from '@mui/material';

import useFileUpload, {
  fileUploadTypes,
} from '../../../hooks/FileUpload/useFileUpload';
import { ReactComponent as UploadIcon } from '../../../assets/svg/fileUploadIcon.svg';
import { fileTypes } from '../UploadButton/UploadButton';
import strings from '../../../localization';
import UploadDialog from '../UploadDialog';

import styles from './styles';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { resetDialog } from '../../../reducers/dialogReducer';

interface IFileUploadType {
  type: fileUploadTypes;
  setFile: React.Dispatch<
    React.SetStateAction<{
      url: string;
      name: string;
    } | null>
  >;
  file: {
    url: string;
    name: string;
  } | null;
}

interface ITempFile {
  url: string;
  name: string;
}

const acceptedExtensions = '.pdf, .doc, .docx, .jpeg, .png, .jpg';

const FileUpload: FC<IFileUploadType> = ({ type, file, setFile }) => {
  console.log(file);
  const dispatch = useAppDispatch();
  const { fileName, fileUri, onDelete, onUpload, customOpenDocument } = useFileUpload(type) ?? {};
  const [tempFile, setTempFile] = useState<ITempFile | null>(null);

  const onSubmit = (values: FormikValues) => {
    setFile(tempFile);
    dispatch(resetDialog());
    onUpload(values);
  };

  const formik = useFormik({
    initialValues: {
      file: {
        name: fileName,
        size: null,
      },
      isFileChanged: false,
    },
    enableReinitialize: true,
    onSubmit,
  });

  const onSelect = (selectedFile: File) => {
    formik.setFieldValue('isFileChanged', true);

    const url = URL.createObjectURL(selectedFile);
    setTempFile({ url, name: selectedFile?.name });
  };

  const openDocument = () => {
    if (tempFile?.url) {
      window.open(tempFile?.url ?? fileUri);
      return;
    }

    customOpenDocument?.() ?? window.open(tempFile?.url ?? fileUri);
  };

  const handleClear = () => {
    formik.setFieldValue('file', null);
    formik.setFieldValue('isFileChanged', false);
    setTempFile(null);
    setFile(null);
    onDelete?.();
  };

  useEffect(() => {
    if (file?.name) {
      formik.setFieldValue('file', { name: file?.name, size: null });
      setTempFile(file);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return (
    <UploadDialog
      fileType={fileTypes.all}
      formik={formik}
      message={strings.sizeOfResume}
      name="file"
      fileSize={2000}
      chooseLabel={strings.uploadFile}
      onSelect={onSelect}
      errorMessage={strings.sizeOfResume}
      acceptedFileTypes={acceptedExtensions}
      handleClear={handleClear}
      handleOpen={openDocument}
      disableButton={!formik.values?.isFileChanged}
      customComponent={(
        <Box sx={styles.root}>
          <UploadIcon width={80} height={80} />
        </Box>
      )}
    />
  );
};

export default FileUpload;
